import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import vuetify from './plugins/vuetify';
import Vuex from 'vuex';
import Auth from './auth';
import NProgress from 'nprogress';
import axios from 'axios';
import VueAxios from 'vue-axios';
import { EventBus } from './events';
import './assets/css/global.scss';
import 'nprogress/nprogress.css'
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);
Vue.config.productionTip = false
Vue.prototype.$EventBus = EventBus
Vue.use(Vuex);
Vue.use(Vuetify);
Vue.use(Auth);
Vue.use(VueAxios, axios);

declare let window: any; // <--- Declare it like this
window.NProgress = NProgress;
NProgress.configure({speed: 1000, showSpinner: false, trickleSpeed: 100 });

// if you want to connect local service copy all from ".env" create a new file ".env.development.local" paste and change values
axios.defaults.baseURL = process.env.VUE_APP_SERVICE_URL;
//Locally
// axios.defaults.baseURL = 'http://localhost:50186/';
//DEV
/* axios.defaults.baseURL = 'http://door-api.rrota.org/'; */
//Production
// Vue.axios.defaults.baseURL = 'https://sit-api.wertheim.at/';
//Developement
// Vue.axios.defaults.baseURL = 'https://doorconfigurator-api.rrota.com/';


const token = localStorage.getItem('token')

if (token) {
  Vue.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

// Interceptors for error handling
axios.interceptors.response.use(response => {
  return response;
}, error => {
    const response = error.response;
    if (response.status == 401) {
      store.dispatch("logout");
      store.getters.destroyToken;
      router.push({
        name: "Login",
      });
    }
    return Promise.reject(error);
})

async function init() {
  var { data } = await axios.get('/api/translate/GetTranslatedLabels')
  // console.log(data)

  const i18n = new VueI18n({
    locale: store.getters.getCurrentUser.preferedLanguage ? store.getters.getCurrentUser.preferedLanguage.isO639 : 'de',
    // fallbackLocale: 'en',
    // store.getters.getCurrentUser.preferedLanguage.isO639 ? store.getters.getCurrentUser.preferedLanguage.isO639 : 
    messages: data
  })

  new Vue({
    router,
    store,
    i18n,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}


init();
